import {useEffect, useState} from 'react'
import {breakpointRanges} from '@/config/breakpoints'
import {isEditing} from '@builder.io/sdk-react'
import useMediaQuery from '@/hooks/useMediaQuery'

const useBuilderMediaQuery = (size) => {
    const [matches, setMatches] = useState(false)

    useEffect(() => {
        const inBuilder = isEditing()
        if (typeof window === 'undefined' || !inBuilder) return

        const evaluateMatch = () => {
            let width = window.innerWidth

            const range = breakpointRanges[size]
            if (!range) return false

            const {min = 0, max = Infinity} = range
            return width >= min && width <= max
        }

        const updateMatch = () => setMatches(evaluateMatch())

        updateMatch()
        window.addEventListener('resize', updateMatch)

        return () => window.removeEventListener('resize', updateMatch)
    }, [size])

    return matches
}

export const useMediaQueryWithBuilder = () => {
    const isInBuilder = isEditing()

    const builderMobile = useBuilderMediaQuery('xs')
    const builderTablet = useBuilderMediaQuery('sm')
    const builderDesktop = useBuilderMediaQuery('lg')
    const builderLargeDesktop = useBuilderMediaQuery('xl')

    const runtimeMobile = useMediaQuery('xs')
    const runtimeTablet = useMediaQuery('sm')
    const runtimeDesktop = useMediaQuery('lg')
    const runtimeLargeDesktop = useMediaQuery('xl')

    return {
        isMobile: isInBuilder ? builderMobile : runtimeMobile,
        isTablet: isInBuilder ? builderTablet : runtimeTablet,
        isDesktop: isInBuilder ? builderDesktop : runtimeDesktop,
        isLargeDesktop: isInBuilder ? builderLargeDesktop : runtimeLargeDesktop
    }
}
